import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/content-header/content-header.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 */
export { ContentHeaderService } from '@ng/core/content-header/content-header.service';

export const ContentHeaderServiceModule = angular.module('acme.common.service.contentHeader', []).name;
